import Icon from "../ui/Icon";
import i18n from "@euroland/libs/locale/i18n";
import { TableData } from "@euroland/react-table";

const OtherMarketInfoTable = ({ body, caption, title }) => {
  return (
    <>
      {body.map((data, i) => {
        let dataName = Object.keys(data)[0];
        let col1 = data[dataName].bodyColFirstentry;
        let col2 = data[dataName].bodyColSecondtentry;
        let head1 = data[dataName].headerColFirstentry;
        let head2 = data[dataName].headerColSecondtentry;
        let className = dataName.toLowerCase();
        if (className === "historicaldata") className = "historical_data";
        const tableTitle = title[dataName] || dataName;
        return (
          <div
            id={dataName.toLowerCase()}
            className={dataName.toLowerCase() + "-dynamicbox-content"}
            key={i}
          >
            <table className="quad-per-inner-flex-data-table" role="table">
              <tbody>
                <tr className="flex-tr">
                  <td className="flex-td">
                    {col1 && (
                      <TableData
                        className="quadrata-share-data-table"
                        design="table-quadrata"
                        hiddenHeader={false}
                        hiddenFooter={true}
                        body={col1}
                        header={head1}
                        theadChild = {
                            <tr>
                              <th data-column="fieldName" scope="col">{i18n.translate("fieldName")}</th>
                              <th data-column="fieldValue" scope="col">{i18n.translate("fieldValue")}</th>
                            </tr>
                        }
                        theadProps={{
                          className: "sr-only table-header"
                        }}
                        headerLeft={true}
                        caption={
                          <p>
                            <Icon name={dataName.toLowerCase()} className={className} />
                            {title[dataName] ? title[dataName] : dataName}
                          </p>
                        }
                        containerProps={{}}
                      ></TableData>
                    )}
                  </td>
                  <td className="flex-td-none"></td>
                  <td className="flex-td">
                    {col2 && (
                      <TableData
                        className="quadrata-share-data-table"
                        design="table-quadrata"
                        hiddenHeader={false}
                        hiddenFooter={true}
                        body={col2}
                        header={head2}
                        theadChild = {
                          <tr>
                            <th data-column="fieldName" scope="col">{i18n.translate("fieldName")}</th>
                            <th data-column="fieldValue" scope="col">{i18n.translate("fieldValue")}</th>
                          </tr>
                        }
                        theadProps={{
                          className: "sr-only table-header"
                        }}
                        headerLeft={true}
                        caption={<span className="sr-only">{tableTitle}</span>}
                        containerProps={{}}
                      ></TableData>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}
    </>
  );
};
export default OtherMarketInfoTable;
